exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#loginWrapper {\r\n\tbackground-image: url(\"/assets/images/login-bg.png\");\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-color: #227471;\r\n\tmin-height: 662px;\r\n\tbackground-position: center;\r\n\tbackground-size: cover;\r\n\tmargin: 0;\r\n\theight: 100%;\r\n}\r\n#ctosLogo{\r\n\tbackground-image: url(\"/assets/images/CTOSLogo.png\");\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-position: center;\r\n\tbackground-size: cover;\r\n\tbackground-color: #227471;\r\n}\r\n\r\n::ng-deep .mat-progress-bar-fill::after {\r\n    background-color: #F15D22;\r\n}\r\n\r\n::ng-deep .mat-progress-bar-buffer {\r\n    background: #E4E8EB;\r\n}\r\n\r\n::ng-deep .mat-progress-bar {\r\n    border-radius: 2px;\r\n}\r\n#ddmfLogo{font-size:72px;color:#FFF;font-weight:bold;}\r\n.discription{font-size:40px;color:#FFF;font-weight:bold;}\r\n#underLine{margin-left:4%;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = 458
// module chunks = 1